import { render, staticRenderFns } from "./dresserList.vue?vue&type=template&id=58047214&scoped=true&"
import script from "./dresserList.vue?vue&type=script&lang=js&"
export * from "./dresserList.vue?vue&type=script&lang=js&"
import style0 from "./dresserList.vue?vue&type=style&index=0&id=58047214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58047214",
  null
  
)

export default component.exports